import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import CustomShipViaAccountNumberState from "@tCentro/Store/Reducer/CustomShipViaAccountNumberState";
import { Draft } from "immer";

const initialState: CustomShipViaAccountNumberState = {
    collectAccountNumber: "",
};
export default createTypedReducerWithImmer(initialState, {
    "Custom/CheckoutReview/SetAccountNumber": (
        draft: Draft<CustomShipViaAccountNumberState>,
        action: { collectAccountNumber: string },
    ) => {
        draft.collectAccountNumber = action.collectAccountNumber;
    },
});
